import React from "react";
import { Route, Switch } from "react-router-dom";
import Loadable from "react-loadable";

// import asyncComponent from "./components/AsyncComponent";
// import AppliedRoute from "./components/AppliedRoute";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";
import AdminAuthenticatedRoute from "./components/AdminAuthenticatedRoute";

import LoadingComponent from "./components/LoadingComponent";

import LandingContainer from "./containers/Landing";

const AsyncLanding = Loadable({
  loader: () => import("./containers/Landing"),
  loading: LoadingComponent
});
const AsyncLogin = Loadable({
  loader: () => import("./containers/Login"),
  loading: LoadingComponent
});
const AsyncSignup = Loadable({
  loader: () => import("./containers/Signup"),
  loading: LoadingComponent
});
const AsyncProfile = Loadable({
  loader: () => import("./containers/Profile"),
  loading: LoadingComponent
});
const AsyncTermsAndConditions = Loadable({
  loader: () => import("./containers/TermsAndConditions"),
  loading: LoadingComponent
});
const AsyncAbout = Loadable({
  loader: () => import("./containers/About"),
  loading: LoadingComponent
});
const AsyncPrivacyPolicy = Loadable({
  loader: () => import("./containers/PrivacyPolicy"),
  loading: LoadingComponent
});

//
const AsyncNotFound = Loadable({
  loader: () => import("./containers/NotFound"),
  loading: LoadingComponent
});

const AsyncWormholes = Loadable({
  loader: () => import("./containers/v2/MyActiveWormholeContainer"),
  loading: LoadingComponent
});

const AsyncExpiredWormholes = Loadable({
  loader: () => import("./containers/v2/MyExpiredWormholeContainer"),
  loading: LoadingComponent
});

const AsyncSearchForWormholes = Loadable({
  loader: () => import("./containers/v2/SearchForWormholeContainer"),
  loading: LoadingComponent
});

const AsyncWishlistWormholes = Loadable({
  loader: () => import("./containers/v2/MyWishlistWormholeContainer"),
  loading: LoadingComponent
});

const AsyncMyCurrentBids = Loadable({
  loader: () => import("./containers/v2/MyCurrentBidsContainer"),
  loading: LoadingComponent
});

const AsyncEmailVerification = Loadable({
  loader: () => import("./containers/EmailVerification"),
  loading: LoadingComponent
});

const AsyncVerifyEmail = Loadable({
  loader: () => import("./containers/VerifyEmail"),
  loading: LoadingComponent
});

const AsyncForgotPassword = Loadable({
  loader: () => import("./containers/ForgotPassword"),
  loading: LoadingComponent
});

const AsyncChangePassword = Loadable({
  loader: () => import("./containers/ChangePassword"),
  loading: LoadingComponent
});

const AsyncCheckoutWormhole = Loadable({
  loader: () => import("./containers/v2/CheckoutWormholeContainer"),
  loading: LoadingComponent
});

const AsyncCheckoutWormholeSuccess = Loadable({
  loader: () => import("./containers/v2/CheckoutSuccessContainer"),
  loading: LoadingComponent
});

const AsyncAdminCheckoutWormhole = Loadable({
  loader: () => import("./containers/admin/v2/CheckoutWormholeContainer"),
  loading: LoadingComponent
});

const AsyncAdminCheckoutWormholeSuccess = Loadable({
  loader: () => import("./containers/admin/v2/CheckoutSuccessContainer"),
  loading: LoadingComponent
});


const AsyncWormholeProfile = Loadable({
  loader: () => import("./containers/WormholeProfile"),
  loading: LoadingComponent
});

const AsyncAddBid = Loadable({
  loader: () => import("./containers/v2/AddBidContainer"),
  loading: LoadingComponent
});

const AsyncAddBidSuccess = Loadable({
  loader: () => import("./containers/v2/BidSuccessContainer"),
  loading: LoadingComponent
});

const AsyncEditMaxBid = Loadable({
  loader: () => import("./containers/EditMaxBid"),
  loading: LoadingComponent
});

const AsyncFullPayment = Loadable({
  loader: () => import("./containers/v2/FullPaymentContainer"),
  loading: LoadingComponent
});

const AsyncFullPaymentSuccess = Loadable({
  loader: () => import("./containers/v2/FullPaymentSuccessContainer"),
  loading: LoadingComponent
});

const AsyncRenewWormhole = Loadable({
  loader: () => import("./containers/v2/LeaseRenewalContainer"),
  loading: LoadingComponent
});

const AsyncRenewSuccess = Loadable({
  loader: () => import("./containers/v2/RenewalSuccessContainer"),
  loading: LoadingComponent
});

// const AsyncBidSuccess = Loadable({
//   loader: () => import("./containers/v2/BidSuccessContainer"),
//   loading: LoadingComponent
// });

/**
 * Admin panel
 * */
const AsyncManageCoupons = Loadable({
  loader: () => import("./containers/admin/v2/ManageCoupons"),
  loading: LoadingComponent
});

const AsyncManageAdmins = Loadable({
  loader: () => import("./containers/admin/ManageAdmins"),
  loading: LoadingComponent
});

const AsyncManageUsers = Loadable({
  loader: () => import("./containers/admin/ManageUsers"),
  loading: LoadingComponent
});

const AsyncManageWormholes = Loadable({
  loader: () => import("./containers/admin/v2/ManageWormholesContainer"),
  loading: LoadingComponent
});

const AsyncAccessDenied = Loadable({
  loader: () => import("./containers/AccessDenied"),
  loading: LoadingComponent
});

export default ({ childProps }) => (
  <Switch>
    {/*<AppliedRoute
      path="/"
      exact
      component={AsyncLogin}
      props={childProps}
    />
    <AppliedRoute
      path="/signup"
      exact
      component={AsyncSignup}
      props={childProps}
    />
    */}
    <UnauthenticatedRoute
      path="/"
      exact
      component={AsyncLanding}
      props={childProps}
    />
    <UnauthenticatedRoute
      path="/forbidden"
      exact
      component={AsyncAccessDenied}
      props={childProps}
    />
    <UnauthenticatedRoute
      path="/login"
      exact
      component={AsyncLogin}
      props={childProps}
    />
    <UnauthenticatedRoute
      path="/signup"
      exact
      component={AsyncSignup}
      props={childProps}
    />
    <UnauthenticatedRoute
      path="/forgot-password"
      exact
      component={AsyncForgotPassword}
      props={childProps}
    />
    <UnauthenticatedRoute
      path="/reset-password"
      exact
      component={AsyncChangePassword}
      props={childProps}
    />
    <UnauthenticatedRoute
      path="/email-verification"
      exact
      component={AsyncEmailVerification}
      props={childProps}
    />
    <UnauthenticatedRoute
      path="/verify-email"
      exact
      component={AsyncVerifyEmail}
      props={childProps}
    />
    <UnauthenticatedRoute
      path="/terms"
      exact
      component={AsyncTermsAndConditions}
      props={childProps}
    />
    <UnauthenticatedRoute
      path="/about"
      exact
      component={AsyncAbout}
      props={childProps}
    />
    <UnauthenticatedRoute
      path="/privacy-policy"
      exact
      component={AsyncPrivacyPolicy}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/my-wormholes"
      exact
      component={AsyncWormholes}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/my-expired-wormholes"
      exact
      component={AsyncExpiredWormholes}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/my-wishlist"
      exact
      component={AsyncWishlistWormholes}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/my-current-bids"
      exact
      component={AsyncMyCurrentBids}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/search-for-wormholes"
      exact
      component={AsyncSearchForWormholes}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/profile"
      exact
      component={AsyncProfile}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/admin/view-profile/:id"
      exact
      component={AsyncProfile}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/checkout-wormhole"
      exact
      component={AsyncCheckoutWormhole}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/checkout-wormhole-result"
      exact
      component={AsyncCheckoutWormholeSuccess}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/admin/checkout-wormhole"
      exact
      component={AsyncAdminCheckoutWormhole}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/admin/checkout-wormhole-result"
      exact
      component={AsyncAdminCheckoutWormholeSuccess}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/wormhole-profile"
      exact
      component={AsyncWormholeProfile}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/add-bid"
      exact
      component={AsyncAddBid}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/bid-result"
      exact
      component={AsyncAddBidSuccess}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/edit-max-bid"
      exact
      component={AsyncEditMaxBid}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/full-payment"
      exact
      component={AsyncFullPayment}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/full-payment-result"
      exact
      component={AsyncFullPaymentSuccess}
      props={childProps}
    />
    <AdminAuthenticatedRoute
      path="/admin/manage-admins"
      exact
      component={AsyncManageAdmins}
      props={childProps}
    />
    <AdminAuthenticatedRoute
      path="/admin/manage-coupons"
      exact
      component={AsyncManageCoupons}
      props={childProps}
    />
    <AdminAuthenticatedRoute
      path="/admin/manage-users"
      exact
      component={AsyncManageUsers}
      props={childProps}
    />
    <AdminAuthenticatedRoute
      path="/admin/manage-wormholes"
      exact
      component={AsyncManageWormholes}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/renew-wormhole"
      exact
      component={AsyncRenewWormhole}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/renew-result"
      exact
      component={AsyncRenewSuccess}
      props={childProps}
    />
    {/*<AuthenticatedRoute*/}
      {/*path="/bid-result"*/}
      {/*exact*/}
      {/*component={AsyncBidSuccess}*/}
      {/*props={childProps}*/}
    {/*/>*/}
    {/*
    <AuthenticatedRoute
      path="/notes/new"
      exact
      component={AsyncNewNote}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/notes/:id"
      exact
      component={AsyncNotes}
      props={childProps}
    />
    */}
    {/* Finally, catch all unmatched routes */}
    <Route component={AsyncNotFound} />
  </Switch>
);

Route.location;



// WEBPACK FOOTER //
// ./src/Routes.js